export default "__VITE_ASSET__CFjWQx$v__"